const findPwd = {
  path: 'findPwd',
  component: resolve => require(['../../../../pages/home/user/find-pwd'], resolve)
}

export default findPwd



// WEBPACK FOOTER //
// ./src/router/home/user/find-pwd/index.js